module.exports = __webpack_public_path__ + "img/phone.886a5579.svg";